import { filter, map } from "rxjs/operators";
import { startRequestLoading, endRequestLoading } from "../actions/ui";
import { getCall } from "../utils/apiLoading";
import { requestFlowActionsRegex, requestActionRegex } from "../constants/apiLoading";
/**
 * Epic for handling which api call is being sent and which is done
 */ export var apiLoadingEpic = function(action$) {
    return action$.pipe(filter(function(action) {
        return requestFlowActionsRegex.test(action.type);
    }), map(function(action) {
        var type = action.type;
        var isRequestBeingSent = requestActionRegex.test(type);
        var call = getCall(type);
        if (isRequestBeingSent) {
            return startRequestLoading(call);
        }
        return endRequestLoading(call);
    }));
};
export default apiLoadingEpic;

//# sourceMappingURL=apiLoadingEpic.js.map